import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';

import { productPropType } from '../../../types';
import intlEquipped, { propTypes as i18nPropTypes } from '../../../hocs/intlEquipped';

import InlineSection from '../../InlineSection/InlineSection';
import ProductItem from '../ProductItem';

const ProductsList = ({ products, total, theme, i18n }) => {
    const { formatPrice, formatMessage } = i18n;

    const renderListHeader = () => (
        <div className={ theme.header }>
            <div className={ theme.number }>{ formatMessage('products.list.label.number') }</div>
            <div className={ theme.items }>
                <InlineSection
                    theme={ theme }
                    mainContent={
                        <span>{ formatMessage('products.list.label.product') }</span>
                    }
                    subContent={
                        <span>{ formatMessage('products.list.label.price', { currency: total.currency }) }</span>
                    }
                    className={ theme.description }
                />
            </div>
        </div>
    );

    const renderProductsList = () => products.map((product, index) => (
        <ProductItem
            key={ `${product.productName}-${product.serviceStartDate}` }
            number={ index + 1 }
            product={ product }
        />
    ));

    const renderSummary = () => (
        <div className={ theme.summary }>
            <div className={ theme.number } />
            <div className={ theme.items }>
                <Divider className={ theme.divider } />
                <InlineSection
                    theme={ theme }
                    mainContent={ <span>{ formatMessage('products.list.total') }</span> }
                    subContent={ <span>{ formatPrice(total) }</span> }
                    className={ theme.description }
                />
            </div>
        </div>
    );

    return (
        <Card className={ theme.productsList } elevation={ 0 }>
            { renderListHeader() }
            { renderProductsList() }
            { renderSummary() }
        </Card>
    );
};

ProductsList.propTypes = {
    total: PropTypes.shape({
        currency: PropTypes.string.isRequired,
        amount: PropTypes.number.isRequired,
    }).isRequired,
    products: PropTypes.arrayOf(productPropType).isRequired,
    theme: PropTypes.shape({}),
    i18n: i18nPropTypes,
};

export default intlEquipped(ProductsList);
